import { skilllist } from "../../data/personal";

import SkillBar from "./SkillBar.js";

function Skills() {
  const jsonArray = Object.entries(skilllist);
  return (
    <>
      <section className="section skills" id="skills">
        <div className="container">
          <p className="section-subtitle">My Skills</p>

          <h2 className="h2 section-title">I Develop Skills Regularly</h2>

          <p className="section-text"></p>

          <ul className="skills-list">
            {jsonArray.map(([k, v]) => {
              return <SkillBar name={k} value={v} key={k} />;
            })}
          </ul>
        </div>
      </section>
    </>
  );
}
export default Skills;
